"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _DOMShims = require("./utils/DOMShims");

var _AlertStyles = _interopRequireDefault(require("./views/AlertStyles"));

var AlertStyleInjector =
/*#__PURE__*/
function () {
  function AlertStyleInjector() {
    (0, _classCallCheck2.default)(this, AlertStyleInjector);
    this.hasInjected = false;
  }

  (0, _createClass2.default)(AlertStyleInjector, [{
    key: "inject",
    value: function inject() {
      if (this.hasInjected) return;
      var headElement = document.getElementsByTagName("head")[0];

      if ((0, _DOMShims.isElement)(headElement)) {
        var styleEl = _AlertStyles.default.getCss();

        headElement.appendChild(styleEl);
        this.hasInjected = true;
        return true;
      }
    }
  }]);
  return AlertStyleInjector;
}();

var _default = new AlertStyleInjector();

exports.default = _default;
module.exports = exports.default;